<template>
  <a-spin :spinning="loadingInsights">
    <a-row>
      <apexchart height="400px"  type="bar" :options="opensChartsOptions" :series="opensChartsSeries"></apexchart>
    </a-row>
  </a-spin>
</template>

<script>
  import utils from '../service/service.js'
  import detailHover from "@/components/DetailHover.vue";
  import moment from "moment";

  export default {
    name: 'EmailInsights',
    components: {
    },
    props: {
      mailing: {}
    },
    mixins:[utils],
    data() {
      return {
        opensChartsOptions: {
          title: {
            text: 'Opens by hour',
          },
          chart: {
            id: 'vuechart-example'
          },
          legend: {
            show: false,
          },

          plotOptions: {
            bar: {
              distributed: true, // this line is mandatory
            },
          },
          xaxis: {
            categories: ['00','01','02','03','04','05','06','07','08','09',10,11,12,13,14,15,16,17,18,19,20,21,22,23]
          },
          tooltip: {
            x:{
              formatter: function(e) {
                return e + ' hs'
              }
            }
          }
        },
        opensChartsSeries: [],
        loadingInsights: false,
      }
    },
    mounted: function() {
      this.getInsights();
    },
    methods:{
      getInsights(reload = false) {
        this.loadingInsights = !reload;
        this.sendRequest({
          method: 'GET',
          url:'mailings/insights/' + this.mailing.id
        }).then(({data})=>{
          if(!reload) {
            let colors = [];
            const H = new Date(this.mailing.sent_at).getHours()
            for (let i=0;i<=23;i++) {
              colors.push(H === i? '#25af60':'#1890ff');
            }
            this.opensChartsOptions = {
              colors
            }
            this.loadingInsights = false;
          }
          this.opensChartsSeries = [{
            name: 'opens',
            data: data.opens
          }];
        })
      },
    },
    watch: {
      mailing: function() {
        this.getInsights(true);
      }
    }

  }
</script>